import FormItemData from "@/components/antd/form";
import {ACTION_METHOD_OBJ} from "@/constants";
import {API} from "@/network/http";
import {BaseUpsertFormProps} from "@/typing/common";
import {Button, Card, Form, Modal, Row} from "antd";
import React, {forwardRef, useEffect, useImperativeHandle} from "react";
import {DEFINE_MODULE} from "../constants";

const UpsertForm: React.FC<BaseUpsertFormProps> = forwardRef((props, ref) => {
  const {modalVisible, onCancel, onSubmit, actionType, values, loadingBtn} = props;
  const [form] = Form.useForm();

  // as the second argument
  useImperativeHandle(ref, () => ({
    onResetData() {
      // reset sale table
      form.resetFields();
    },
  }));

  const getListLocation = async (searchValue?: string) => {
    const response = await API.locations.locationControllerGetMany({name: searchValue});
    return (
      response?.data?.data?.map((item: any) => ({
        value: item._id,
        key: item._id,
        name: item.name,
      })) || []
    );
  };

  useEffect(() => {
    if (actionType === "UPDATE") {
      form.setFieldsValue({
        code: values.code,
        locationId: values.locationId,
        maxQuantity: values.maxQuantity,
      });
    }
  }, []);

  const handleSubmit = async () => {
    const fieldsValidation = await form.validateFields();
    if (!fieldsValidation) {
      return;
    }
    const formValues = {...form.getFieldsValue()};
    if (actionType === "CREATE") {
      onSubmit(formValues, actionType);
    }
    if (actionType === "UPDATE") {
      onSubmit(formValues, actionType, values._id);
    }
  };

  const onResetForm = (): void => {
    // reset sale table
    form.resetFields();
  };

  const renderContentList = [
    {
      inputType: "input",
      name: "code",
      label: "Mã phòng học",
      placeholder: "Nhập mã phòng học",
      rules: [{required: true, message: "Nhập mã phòng học"}],
    },
    {
      inputType: "selectsearch",
      name: "locationId",
      label: "Cơ sở",
      placeholder: "Chọn buổi",
      fetchOptions: getListLocation,
      rules: [{required: true, message: "Chọn buổi"}],
    },
    {
      inputType: "number",
      name: "maxQuantity",
      label: "Sức chứa tối đa",
      placeholder: "Nhập sức chứa tối đa",
      rules: [{required: true, message: "Nhập sức chứa tối đa"}],
    },
  ];

  const renderContent = () => {
    return (
      <Card style={{paddingRight: "20px"}}>
        <Row gutter={24}>{renderContentList.map(item => item && <FormItemData key={item.name} {...item} />)}</Row>
      </Card>
    );
  };

  const renderFooter = () => {
    return (
      <>
        {props.actionType === "CREATE" && <Button onClick={() => onResetForm()}>Làm mới</Button>}
        <Button loading={loadingBtn} type="primary" onClick={handleSubmit}>
          Đồng ý
        </Button>
      </>
    );
  };

  return (
    <>
      <Modal
        bodyStyle={{background: "#F0F2F5"}}
        width={700}
        destroyOnClose
        maskClosable={false}
        title={`${ACTION_METHOD_OBJ[actionType]} ${DEFINE_MODULE.name}`}
        visible={modalVisible}
        onCancel={() => {
          onResetForm();
          onCancel();
        }}
        footer={renderFooter()}
      >
        <Form layout="vertical" form={form}>
          {renderContent()}
        </Form>
      </Modal>
    </>
  );
});

export default UpsertForm;
